import { useRef, useState } from 'react'
import { useTheme } from 'next-themes'
import { CloseSessionModal } from '../CloseSessionModal/CloseSessionModal'
import { useRipple } from '@/hooks/useRipple'

const CloseSessionButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef(null)
  useRipple(ref, 'rgb(169, 174, 179, 0.3)')

  const { resolvedTheme } = useTheme()

  const closeModal = () => {
    setIsOpen(false)
  }

  const openModal = () => {
    setIsOpen(true)
  }

  return (
    <>
      <button
        ref={ref}
        className="hover:opacity-80 relative w-10 h-10 p-2 overflow-hidden rounded-full"
        onClick={openModal}
      >
        {isOpen ? (
          <ExitSvgEmpty
            fill={resolvedTheme === 'dark' ? '#e0e0e0' : '#323e48'}
          />
        ) : (
          <ExitSvgFill />
        )}
      </button>
      {isOpen && <CloseSessionModal isOpen={isOpen} closeModal={closeModal} />}
    </>
  )
}

const ExitSvgFill = ({ fill = '#6b7280' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill={fill}>
      <path d="M168 432H96c-26.4 0-48-21.6-48-48V128c0-26.4 21.6-48 48-48h72C181.3 80 192 69.25 192 56C192 42.74 181.3 32 168 32H96C42.98 32 0 74.98 0 128v256c0 53.02 42.98 96 96 96h72C181.3 480 192 469.3 192 456C192 442.7 181.3 432 168 432zM503.9 238.6L351.5 104.4c-9.844-8.75-24-10.88-36.09-5.469C303.6 104.3 296 115.9 296 128.7v55.31H176c-22.06 0-40 17.94-40 40v64c0 22.06 17.94 40 40 40h120v55.31c0 12.75 7.625 24.41 19.41 29.72c4.438 2 9.156 2.969 13.84 2.969c8.062 0 16.03-2.906 22.25-8.438l152.4-133.1C509.1 269.9 512 263.4 512 256.5S509.1 243.1 503.9 238.6zM344 350V279.1h-160v-48h160V161.1l107.8 94.54L344 350z" />
    </svg>
  )
}
const ExitSvgEmpty = ({ fill = '#6b7280' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill={fill}>
      <path d="M96 480h64C177.7 480 192 465.7 192 448S177.7 416 160 416H96c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h64C177.7 96 192 81.67 192 64S177.7 32 160 32H96C42.98 32 0 74.98 0 128v256C0 437 42.98 480 96 480zM504.8 238.5l-144.1-136c-6.975-6.578-17.2-8.375-26-4.594c-8.803 3.797-14.51 12.47-14.51 22.05l-.0918 72l-128-.001c-17.69 0-32.02 14.33-32.02 32v64c0 17.67 14.34 32 32.02 32l128 .001l.0918 71.1c0 9.578 5.707 18.25 14.51 22.05c8.803 3.781 19.03 1.984 26-4.594l144.1-136C514.4 264.4 514.4 247.6 504.8 238.5z" />
    </svg>
  )
}

export default CloseSessionButton
